/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { htmlSafe } from '@ember/template';
import { tracked } from '@glimmer/tracking';
import { Task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import escape from 'cio/utils/escape';
import LogModel from 'cio/models/log';
import EventModel from 'cio/models/event';

interface EventLogsStatusArgs {
  eventLogs: LogModel[];
  totalLogs: LogModel[];
  event: EventModel;
  isDataFilter: boolean;
  isRunning: boolean;
  isError: boolean;
  readonly: boolean;
  refetchLogs?: Task<unknown, []>;
}

export default class EventLogsStatus extends Component<EventLogsStatusArgs> {
  @service features!: FeaturesService;

  @tracked log: LogModel | null = null;
  @tracked isShowingEventDataModal = false;
  @tracked isShowingSendTestEventModal = false;

  get oldUI() {
    return !this.features.isEnabled('campaign_trigger_ui_new');
  }

  get eventDataFilterTitle() {
    return htmlSafe(
      `<span>${this.args.eventLogs.length} of ${this.args.totalLogs.length} <b>${escape(
        this.args.event,
      )}</b> events match your data filters</span>`,
    );
  }

  get eventFilterTitle() {
    return htmlSafe(`<span>${this.args.eventLogs.length} <b>${escape(this.args.event)}</b> events</span>`);
  }

  @action
  onSendTestWithLog(log: LogModel) {
    this.log = log;
    this.isShowingSendTestEventModal = true;
    this.isShowingEventDataModal = false;
  }

  @action
  onCloseModal() {
    this.log = null;
    this.isShowingSendTestEventModal = false;
    this.isShowingEventDataModal = false;
  }
}
